/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectRecallRequest } from '../models/ConnectRecallRequest';
import type { ConnectRecallResponse } from '../models/ConnectRecallResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RecallIntegrationService {
    /**
     * Connect Recall
     * Connect to a Google Meet via Recall AI bot.
     *
     * Args:
     * request: Contains
     * widget_host_url
     * meet_link
     * bot_name: name that bot will have when joins meeting
     * bg_info: long text, context added to agent on start
     * token: Bearer token for authentication
     *
     * Returns:
     * ConnectRecallResponse with bot ID and status
     * @param requestBody
     * @returns ConnectRecallResponse Successful Response
     * @throws ApiError
     */
    public static connectRecallConnectRecallPost(
        requestBody: ConnectRecallRequest,
    ): CancelablePromise<ConnectRecallResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/connect_recall',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
